(function ( ) {

    let navToggle = document.getElementById('nav-toggle'),
            siteNavigation = document.getElementById('site-navigation')


    navToggle.addEventListener('click', function (e) {
        e.stopPropagation()
        document.body.classList.toggle('menu-open')
        var x = 'true' == navToggle.getAttribute('aria-expanded') ? 'false' : 'true'
        navToggle.setAttribute('aria-expanded', x)
    })

    // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
    document.addEventListener('click', function (e) {
        if (!siteNavigation.contains(e.target)) {
            document.body.classList.remove('menu-toggled')
            navToggle.setAttribute('aria-expanded', 'false')
        }
    });

    jQuery(function($) {
        let win = $(window).width();
        scrollFunction(win);
        window.onscroll = function () {
            scrollFunction(win)
        }

        $(window).on('resize', function () {
            win = $(this).width();
            if (win > 1150) {
                $('body').removeClass('menu-open')
            } else {
                $('header').removeClass('sticky');
            }
        });

        function scrollFunction(win) {
            if (win > 1150) {
                if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                    if (!$('header').hasClass('sticky')) {
                        $('header').addClass('sticky');
                    }
                } else {
                    if ($('header').hasClass('sticky')) {
                        $('header').removeClass('sticky');
                    }
                }
            }
        }

        $('.search-top-menu-item a').text('');
    })


})()
